<app-navbar></app-navbar>

<div #smoothWrapper class="fixed top-0 left-0 w-full h-screen overflow-hidden">
  <div #smoothContent class="will-change-transform">
<section class="pt-[80px]">
    <div class="px-5 md:px-16 py-0 md:py-10 gap-10 md:gap-0 w-full mx-auto flex flex-col md:flex-row justify-between items-start">
        <div class="pt-16 flex flex-col gap-10 md:sticky top-20">
            <span class="text-[3rem] leading-5 tracking-[-.015em] block">Contáctenos</span>
            <p class="tracking-[-.0025em] font-normal max-w-[30ch] block leading-[1.6] text-lg text-gray-800">Por favor complete el formulario a continuación, un miembro de nuestro equipo atenderá su solicitud lo más pronto posible.</p>
        </div>
    
        <div class="rounded-xl bg-slate-50 min-h-[500px] max-w-180 w-full py-10 px-5 md:px-10">
            <div class="w-full flex flex-col gap-6">
                <h3 class="font-normal!">Estoy interesado en</h3>
    
                <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <label class="relative flex cursor-pointer flex-col gap-7 rounded-md px-4 py-3 bg-white hover:bg-slate-200 transition-colors" [ngClass]="{'bg-sky-100!': contact_type == 'product'}" (click)="selectContactType('product')">
                        <small>Producto</small>
                        <span class="text-[.9rem]">Adquisición del producto</span>
                    </label>
    
                    <label class="relative flex cursor-pointer flex-col gap-7 rounded-md px-4 py-3 bg-white hover:bg-slate-200 transition-colors" [ngClass]="{'bg-sky-100!': contact_type == 'services'}" (click)="selectContactType('services')">
                        <small>Servicios</small>
                        <span class="text-[.9rem]">Servicio al cliente</span>
                    </label>
    
                    <label class="relative flex cursor-pointer flex-col gap-7 rounded-md px-4 py-3 bg-white hover:bg-slate-200 transition-colors" [ngClass]="{'bg-sky-100!': contact_type == 'pqr'}" (click)="selectContactType('pqr')">
                        <small>PQR's</small>
                        <span class="text-[.9rem]">Peticiones, quejas, reclamos</span>
                    </label>
                </div>
    
                <div>
                    <p class="pb-3">Descripción general</p>
                    <small class="font-light text-gray-700">Drazamed busca dar solución a sus necesidades, estamos dispuestos a atender sus solicitudes.</small>
                </div>
    
                <div>
                    <p class="pb-3">Información</p>
    
                    <form class="flex flex-col mt-3 gap-4" (ngSubmit)="submitContact()">
                        <input type="text" class="input_form" pInputText placeholder="Nombre completo"  autocomplete="xyz123">
    
                        <input type="email" class="input_form" pInputText placeholder="Correo electrónico"  autocomplete="xyz123">
    
                        @if (contact_type == 'product' || contact_type == 'services') {
                            <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
                                <input type="text" class="input_form" pInputText placeholder="Nombre de la empresa"  autocomplete="xyz123">
                                <input type="text" class="input_form" pInputText placeholder="Cantidad de usuarios" [maskito]="masks.idNumber"  autocomplete="xyz123">
                            </div>
                        }

                        <textarea rows="5" class="input_form resize-none" pInputText placeholder="Mensaje..."  autocomplete="xyz123"></textarea>
    
                        
    
                        <small class="mt-3 text-gray-600">Al hacer click en "contactar" esta aceptando los términos y condiciones de servicio</small>
    
                    </form>
                </div>
            </div>
        </div>
    </div>

    <app-footer></app-footer>
</section>
  </div>
</div>

